import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { RQApp }                  from '../RQuery/RQuery';

import { AppModule } from './app.module';

let debug: boolean = true;

RQApp.PageParams.Debug = debug;

if (!debug) {
    var methods = ["log", "debug", "warn", "info"];

    for (var i = 0; i < methods.length; i++) {
        console[methods[i]] = function () { };
    }
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/main.ts